import { Component, ViewChild } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatStepper } from "@angular/material";
import { Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ApiService } from "../../../services/api.service";
import { MemberAccessReason } from "../../../models/member-access-reason.model";
import * as _ from 'lodash';
import { MemberAccess } from "../../../models/member-access.model";
import { Member } from "../../../models/member.model";
import { AlertService, MessageSeverity } from "../../../services/alert.service";
import { MemberAccessActionType } from "../../../models/enums";
import { DependentService } from "../../../services/dependent.service";
import { SnotifyService } from "ng-snotify";

@Component({
    selector: 'change-password-sheet',
    template: require('./change-password-sheet.html'),
    styles: [require('./change-password-sheet.css')],
})




  export class ChangePasswordSheetComponent {

    firstFormGroup: FormGroup;
    member: Member;
    dependent: any;
    hasNoUsername = false;
    @ViewChild('stepper')
    matStepper: MatStepper;

    changeModel: any = {
        newPassword: "",
        confirmPassword: ""
    }



    constructor(private snotify: SnotifyService, private _formBuilder: FormBuilder,
        private dependentService: DependentService,
        private apiService: ApiService, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private bottomSheetRef: MatBottomSheetRef<ChangePasswordSheetComponent>) {

        this.member = data.member;
        this.dependent = data.dependent;
        // Members who never registered have no username yet; default it to their email so the reset gives them one.
        this.hasNoUsername = !!this.member && !this.member.username;
        this.changeModel.username = this.member ? (this.member.username || this.member.email) : this.dependent.email;
        this.firstFormGroup = this._formBuilder.group({
            passwordControl: [],
            confirmPasswordControl: []
        });




    }


    ngOnInit() {

    }

    cancel() {
        this.bottomSheetRef.dismiss();
    }

    updatePassword() {

        if (this.dependent) {
            this.dependentService.updatePassword({ dependentId: this.dependent.dependentId, username: this.dependent.email, password: this.changeModel.newPassword }).subscribe(r => {
                this.snotify.success("Change Dependent's Password Successfully!");
                this.bottomSheetRef.dismiss();
            })
        }
        if (this.member) {
            this.member.password = this.changeModel.newPassword;
            if (this.hasNoUsername)
                this.member.username = this.changeModel.username;
            // Login rejects unverified members, so an admin reset vouches for the account.
            this.member.isVerified = true;

            this.apiService.saveMember(this.member).subscribe(r => {
                this.snotify.success("Change Member's Password Successfully!");
                var newMemberAccess = new MemberAccess();
                newMemberAccess.memberAccessActionType = MemberAccessActionType.ResetPassword;
                newMemberAccess.endTime = new Date();
                newMemberAccess.isResolved = true;
                newMemberAccess.startTime = newMemberAccess.endTime;
                newMemberAccess.note = "Reset Password";
                newMemberAccess.memberId = this.member.memberId;
                this.apiService.createMemberAccess(newMemberAccess).subscribe(res => {

                })


                this.bottomSheetRef.dismiss();
            })
        }
    }

  }




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/members/change-password-sheet/change-password-sheet.ts